/**
 * Copyright (c) 2015-present, Alibaba Group Holding Limited.
 * All rights reserved.
 *
 * @providesModule ReactStyleSheet
 */
'use strict';

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _extendPropertiesWinjs = require('./extendProperties.winjs');

var _extendPropertiesWinjs2 = _interopRequireDefault(_extendPropertiesWinjs);

var _reference = require('./reference');

var _reference2 = _interopRequireDefault(_reference);

var _setDefaultStyleWinjs = require('./setDefaultStyle.winjs');

var _setDefaultStyleWinjs2 = _interopRequireDefault(_setDefaultStyleWinjs);

// Make React support array of style object like React Native

var _extendCreateElement2 = require('./extendCreateElement');

var _extendCreateElement3 = _interopRequireDefault(_extendCreateElement2);

var _flattenStyleWinjs = require('./flattenStyle.winjs');

var _flattenStyleWinjs2 = _interopRequireDefault(_flattenStyleWinjs);

var inited = false;

var ROOT_CLASS_NAME = 'react-root';
var VIEW_CLASS_NAME = 'react-view';

var StyleSheet = {
  create: function create(styles) {
    return styles;
  },
  extendCreateElement: function extendCreateElement(React) {
    (0, _extendCreateElement3['default'])(React, function (style) {
      if (!inited) {
        inited = true;
        (0, _setDefaultStyleWinjs2['default'])({
          reference: _reference2['default'].getWidth(),
          rootClassName: ROOT_CLASS_NAME,
          viewClassName: VIEW_CLASS_NAME
        });
      }

      return (0, _flattenStyleWinjs2['default'])(style, _extendPropertiesWinjs2['default']);
    });
  },
  setReferenceWidth: _reference2['default'].setWidth,
  rootClassName: ROOT_CLASS_NAME,
  viewClassName: VIEW_CLASS_NAME
};

module.exports = StyleSheet;


/** WEBPACK FOOTER **
 ** ./~/react-native-winjs/lib/StyleSheet/StyleSheet.winjs.js
 **/